import { CSSObject } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'epsilon.500',
  mb: '1',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'epsilon.500',
  fontSize: 'xs',
};

export const BoxMoreText: CSSObject = {
  w: '8',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'gray.500',
  mb: '2',
  '&.raceNumber': {
    fontWeight: 'semibold',
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};